import { TextProps } from '@betty/moonlight/lib/common/Text/Text.types';
import { IconProps, NamespacedImageKeys } from '@betty/moonlight';
import { RewardType } from '../../state/rewards.types';

export const REWARD_IMAGES: Record<
  Exclude<RewardType, RewardType.FreeSpins>,
  NamespacedImageKeys
> = {
  [RewardType.Coins]: 'common.BettyCoinStack',
  [RewardType.Cash]: 'common.BettyPiggy',
  [RewardType.Bonus]: 'common.BettyPiggy',
  [RewardType.DailyGift]: 'common.BettyCoinStack',
  [RewardType.DailyWheel]: 'common.BettyCoinStack',
  [RewardType.InstantWheel]: 'common.BettyWheel',
};

export const REWARD_TEXTS: Record<RewardType, TextProps['locKey']> = {
  [RewardType.Coins]: 'bettyCoins',
  [RewardType.Cash]: 'cash',
  [RewardType.Bonus]: 'bonus',
  [RewardType.FreeSpins]: 'freeSpins',
  [RewardType.DailyGift]: 'dailyGift',
  [RewardType.DailyWheel]: 'dailyWheel',
  [RewardType.InstantWheel]: 'wheelSpins',
};

export const REWARD_BUTTON_TEXTS: Record<RewardType, TextProps['locKey']> = {
  [RewardType.Coins]: 'goToBettyShop',
  [RewardType.Cash]: 'ok',
  [RewardType.Bonus]: 'ok',
  [RewardType.FreeSpins]: 'playNow',
  [RewardType.DailyGift]: 'close',
  [RewardType.DailyWheel]: 'close',
  [RewardType.InstantWheel]: 'spinNow',
};

export const REWARD_ICONS: Record<RewardType, IconProps['name']> = {
  [RewardType.Coins]: 'bettyCoin',
  [RewardType.Cash]: 'bettyDollar',
  [RewardType.Bonus]: 'bettyDollar',
  [RewardType.FreeSpins]: 'slotsDark',
  [RewardType.DailyGift]: 'bettyCoin',
  [RewardType.DailyWheel]: 'bettyCoin',
  [RewardType.InstantWheel]: 'spinWheel',
};

export const IMAGE_COMMON_PROPS = {
  contentFit: 'contain',
  width: '100%',
  height: '100%',
  pointerEvents: 'none',
} as const;

export const DEFAULT_ANIMATION_DELAY = 1000;
export const DEFAULT_ANIMATION_DURATION = 1000;
export const TEXT_ANIMATION_DURATION = 250;
